import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import { axiosPrivate } from '../../Helpers/axios';
import { maskMobileNumber } from '../../utils/MobileNumHide';
function* getCphDataResponse({ payload: { offset, limit, search, fromDate, toDate , agentId } }) {
  // let agentId= "12345605947539573"
  try {
    const response = yield call(axiosPrivate.get, `/cou-dashboard/customerpaymenthistory?agentId=${agentId ? agentId : '' }&page=${offset ? offset : 1}&limit=${limit ? limit : 10}${search ? `&search=${search}` : ''}${fromDate ? `&fromDate=${fromDate} ` : ''}${toDate ? `&toDate=${toDate} ` : ''}`);
    yield put(actions.getCphDataSuccess(response?.data?.data, response?.data?.total));
  } catch (error) {
    yield put(actions.getCphDataFailed(error));
  }
}

function* getCphDetailDataResponse({ payload: { mobileNumber,offset, limit, search, fromDate, toDate , agentId } }) {
  // let agentId= "12345605947539573"
  try {
    const response = yield call( axiosPrivate.get, `/cou-dashboard/customerpaymenthistory/${mobileNumber}?page=${offset ? offset : 1}&limit=${limit ? limit : 10}${search ? `&search=${search}` : ''}${fromDate ? `&fromDate=${fromDate} ` : ''}${toDate ? `&toDate=${toDate} ` : ''}${agentId ? `&agentId=${agentId}` : ""}` );
    {
      if (response?.data?.data) {
        response.data.data = response.data.data.map((item) => ({
          ...item,
          mobileNumber: maskMobileNumber(item?.mobileNumber),
          amount: item.amount/100,
        }));
      }
    }
    yield put(actions.getCphDetailDataSuccess(response?.data?.data, response?.data?.total));
  } catch (error) {
    yield put(actions.getCphDetailDataFailed(error));
  }
}


export default function* rootSaga() {
  yield all([takeEvery(actions.GET_CPH_DATA, getCphDataResponse)]);
  yield all([takeEvery(actions.GET_CPHDETAIL_DATA, getCphDetailDataResponse)]);
}



